import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const FilterSection = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    location: '',
    priceRange: '',
    serviceType: '',
    availability: '',
    culturalSpecialization: '',
    rating: '',
    sortBy: 'relevance'
  });

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  const handleFilterChange = (filterType, value) => {
    setSelectedFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  const clearFilters = () => {
    setSelectedFilters({
      location: '',
      priceRange: '',
      serviceType: '',
      availability: '',
      culturalSpecialization: '',
      rating: '',
      sortBy: 'relevance'
    });
  };

  const priceRanges = [
    { value: '0-500', label: '$0 - $500' },
    { value: '500-1000', label: '$500 - $1,000' },
    { value: '1000-2500', label: '$1,000 - $2,500' },
    { value: '2500-5000', label: '$2,500 - $5,000' },
    { value: '5000+', label: '$5,000+' }
  ];

  const serviceTypes = [
    { value: 'solo', label: 'Solo Professional' },
    { value: 'team', label: 'Team Service' },
    { value: 'full-service', label: 'Full Service' },
    { value: 'consultation', label: 'Consultation Only' }
  ];

  const culturalSpecializations = [
    { value: 'punjabi', label: 'Punjabi' },
    { value: 'gujarati', label: 'Gujarati' },
    { value: 'tamil', label: 'Tamil' },
    { value: 'telugu', label: 'Telugu' },
    { value: 'bengali', label: 'Bengali' },
    { value: 'marathi', label: 'Marathi' },
    { value: 'muslim', label: 'Muslim' },
    { value: 'sikh', label: 'Sikh' },
    { value: 'hindu', label: 'Hindu' }
  ];

  const ratings = [
    { value: '4+', label: '4+ Stars' },
    { value: '4.5+', label: '4.5+ Stars' },
    { value: '5', label: '5 Stars Only' }
  ];

  const sortOptions = [
    { value: 'relevance', label: 'Relevance' },
    { value: 'rating', label: 'Rating' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'distance', label: 'Distance' },
    { value: 'newest', label: 'Newest First' }
  ];

  return (
    <div className="bg-white border-b border-border shadow-soft sticky top-16 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile Filter Button */}
        <div className="lg:hidden py-4">
          <Button
            variant="outline"
            size="md"
            iconName="Filter"
            iconSize={18}
            onClick={toggleFilter}
            className="w-full justify-center"
          >
            Filters {isFilterOpen ? '(Open)' : '(Closed)'}
          </Button>
        </div>

        {/* Desktop Filters - Always Visible */}
        <div className="hidden lg:block py-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-4">
            {/* Location Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Location</label>
              <input
                type="text"
                placeholder="City, State, or Zip"
                value={selectedFilters.location}
                onChange={(e) => handleFilterChange('location', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>

            {/* Price Range Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Price Range</label>
              <select
                value={selectedFilters.priceRange}
                onChange={(e) => handleFilterChange('priceRange', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="">All Prices</option>
                {priceRanges.map(range => (
                  <option key={range.value} value={range.value}>{range.label}</option>
                ))}
              </select>
            </div>

            {/* Service Type Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Service Type</label>
              <select
                value={selectedFilters.serviceType}
                onChange={(e) => handleFilterChange('serviceType', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="">All Types</option>
                {serviceTypes.map(type => (
                  <option key={type.value} value={type.value}>{type.label}</option>
                ))}
              </select>
            </div>

            {/* Availability Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Availability</label>
              <input
                type="date"
                value={selectedFilters.availability}
                onChange={(e) => handleFilterChange('availability', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              />
            </div>

            {/* Cultural Specialization Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Cultural Specialization</label>
              <select
                value={selectedFilters.culturalSpecialization}
                onChange={(e) => handleFilterChange('culturalSpecialization', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="">All Cultures</option>
                {culturalSpecializations.map(culture => (
                  <option key={culture.value} value={culture.value}>{culture.label}</option>
                ))}
              </select>
            </div>

            {/* Rating Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Rating</label>
              <select
                value={selectedFilters.rating}
                onChange={(e) => handleFilterChange('rating', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              >
                <option value="">All Ratings</option>
                {ratings.map(rating => (
                  <option key={rating.value} value={rating.value}>{rating.label}</option>
                ))}
              </select>
            </div>

            {/* Sort By Filter */}
            <div className="space-y-2">
              <label className="text-sm font-medium text-text-primary">Sort By</label>
              <select
                value={selectedFilters.sortBy}
                onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
              >
                {sortOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Clear Filters Button */}
          <div className="mt-4 flex justify-end">
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              iconSize={16}
              onClick={clearFilters}
              className="text-text-secondary hover:text-primary"
            >
              Clear All Filters
            </Button>
          </div>
        </div>

        {/* Mobile Filters - Collapsible */}
        {isFilterOpen && (
          <div className="lg:hidden pb-6 space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Location Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Location</label>
                <input
                  type="text"
                  placeholder="City, State, or Zip"
                  value={selectedFilters.location}
                  onChange={(e) => handleFilterChange('location', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                />
              </div>

              {/* Price Range Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Price Range</label>
                <select
                  value={selectedFilters.priceRange}
                  onChange={(e) => handleFilterChange('priceRange', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                >
                  <option value="">All Prices</option>
                  {priceRanges.map(range => (
                    <option key={range.value} value={range.value}>{range.label}</option>
                  ))}
                </select>
              </div>

              {/* Service Type Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Service Type</label>
                <select
                  value={selectedFilters.serviceType}
                  onChange={(e) => handleFilterChange('serviceType', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                >
                  <option value="">All Types</option>
                  {serviceTypes.map(type => (
                    <option key={type.value} value={type.value}>{type.label}</option>
                  ))}
                </select>
              </div>

              {/* Availability Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Availability</label>
                <input
                  type="date"
                  value={selectedFilters.availability}
                  onChange={(e) => handleFilterChange('availability', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                />
              </div>

              {/* Cultural Specialization Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Cultural Specialization</label>
                <select
                  value={selectedFilters.culturalSpecialization}
                  onChange={(e) => handleFilterChange('culturalSpecialization', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                >
                  <option value="">All Cultures</option>
                  {culturalSpecializations.map(culture => (
                    <option key={culture.value} value={culture.value}>{culture.label}</option>
                  ))}
                </select>
              </div>

              {/* Rating Filter */}
              <div className="space-y-2">
                <label className="text-sm font-medium text-text-primary">Rating</label>
                <select
                  value={selectedFilters.rating}
                  onChange={(e) => handleFilterChange('rating', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                >
                  <option value="">All Ratings</option>
                  {ratings.map(rating => (
                    <option key={rating.value} value={rating.value}>{rating.label}</option>
                  ))}
                </select>
              </div>

              {/* Sort By Filter - Full width on mobile */}
              <div className="space-y-2 sm:col-span-2">
                <label className="text-sm font-medium text-text-primary">Sort By</label>
                <select
                  value={selectedFilters.sortBy}
                  onChange={(e) => handleFilterChange('sortBy', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-primary"
                >
                  {sortOptions.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Clear Filters Button */}
            <div className="flex justify-center">
              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                iconSize={16}
                onClick={clearFilters}
                className="text-text-secondary hover:text-primary"
              >
                Clear All Filters
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FilterSection;